import {useEffect, useState} from "react";
import * as Yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup/dist/yup";
import {getUserRole} from "../../../services/auth.service";
import ClientsService from "../../../services/clients.service";
import {elevatorColumns, eventColumns, parcelColumns, userColumns} from "../../../components/Utils/HeaderColumns";
import GHIconButton from "../../../components/GHIconButton";
import MDBadge from "../../../components/MDBadge";
import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import Icon from "@mui/material/Icon";
import MDButton from "../../../components/MDButton";
import MDSnackbar from "../../../components/MDSnackbar";
import Modal from "@mui/material/Modal";
import MDBox from "../../../components/MDBox";
import {modalStyleClients, modalStyleUser} from "../../../components/Utils/ModalStyle";
import Card from "@mui/material/Card";
import MDTypography from "../../../components/MDTypography";
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import MDInput from "../../../components/MDInput";
import TextField from "@mui/material/TextField";
import DataTable from "../../../examples/Tables/DataTable";
import DashboardLayout from "../../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../../examples/Navbars/DashboardNavbar";
import Footer from "../../../examples/Footer";
import EventsService from "../../../services/events.service";
import Switch from "@mui/material/Switch";

function EventList() {

    const defaultInputValues = {  title: "", description: "",
        notificationUser:false, startTime: "08:00" ,
        endTime:"21:00", doDate:  "" };

    const [values, setValues] = useState(defaultInputValues);

    const validationSchema = Yup.object().shape({
        title: Yup.string().trim().required("Event Title is required"),
        doDate: Yup.string().required("Event Date is required"),
        startTime: Yup.string().required("Start Time is required"),
        endTime: Yup.string().required("End Time is required"),
        client: Yup.object().nullable().required("Client is required"),
        building: Yup.object().nullable().required("Building is required"),
        eventType: Yup.object().nullable().required("Event Type is required"),
        unit: Yup.array().min(1, "Unit is required").required("Unit is required"),
        description: Yup.string(),
    });

    const { register, handleSubmit, formState: { errors  } } =
            useForm({mode:"all", resolver:yupResolver(validationSchema)});

const [fieldErrors, setFieldErrors] = useState({});

const validateEventValues = (eventValues) => {
    try {
        validationSchema.validateSync(eventValues, {abortEarly: false});
        setFieldErrors({});
        return true;
    } catch (validationError) {
        const nextErrors = {};
        validationError.inner.forEach((error) => {
            if (error.path && !nextErrors[error.path]) {
                nextErrors[error.path] = error.message;
            }
        });
        setFieldErrors(nextErrors);
        return false;
    }
};

const handleChange = (value) => {
    setValues(value);
    setIsValid(validationSchema.isValidSync(value));
    if (Object.keys(fieldErrors).length > 0) {
        validateEventValues(value);
    }
};

    const [isValid, setIsValid] = useState(false);

    const [selectedInstance, setSelectedInstance] = useState({});
    const [units, setUnits] = useState([]);
    const [buildings, setBuildings] = useState([]);
    const [clients, setClients] = useState([]);
    const [eventType, setEventType] = useState([]);
    // const [selectedEventType, setSelectedEventType] = useState(null);
    //const [selectedBuilding, setSelectedBuilding] = useState(null);
    //const [selectedUnit, setSelectedUnit] = useState(null);

    const [openDialog, setOpenDialog] = useState(false);

    const [infoSB, setInfoSB] = useState(false);
    const [errorSB, setErrorSB] = useState(false);
    const openErrorSB = () => setErrorSB(true);
    const closeErrorSB = () => setErrorSB(false);
    const openInfoSB = () => setInfoSB(true);
    const closeInfoSB = () => setInfoSB(false);
    const [errorMessage, setErrorMessage] = useState("");
    const isAdmin = getUserRole() === "super_admin"
    useEffect(() => {
        loadClients();
        getEvents();
        loadEventType();
    }, [setClients, setBuildings, setUnits]);

    const loadClients = (instance_id) => {
        ClientsService.getClients(instance_id)
        .then((res) => {
            console.log(res.data);
            setClients(res.data);
            if (res.data.length > 0){
                loadBuilding(res.data[0].id);
            }
        })
        .catch((error) => {
            console.log(error);
        });
    }

const handleSaveEvent = () => {
  if (!validateEventValues(values)) {
    setErrorMessage("Please fill all required fields");
    openErrorSB();
    return;
  }

  const payload = {
    name: values.title,
    description: values.description,
    date: values.doDate,
    start_time: values.startTime,
    end_time: values.endTime,
    type: values?.eventType?.id,
    client: values?.client?.id,
    building: values?.building?.id,
    unit: values?.unit?.map(u => u.id),
    notify_member: values.notificationUser
  };

  console.log("EVENT PAYLOAD =", payload);

  EventsService.insertEvent(payload)
    .then((res) => {
      openInfoSB();
      setOpenInsertModel(false);
      getEvents();
    })
    .catch((err) => {
      console.log(err);
      openErrorSB();
    });
};

    const loadBuilding = (client_id) => {
        ClientsService.getClientsBuilding(client_id)
        .then((res) => {
            console.log(res.data);
            setBuildings(res.data);
            if(res.data.length > 0){
                loadUnit(res.data[0].id);
            }
        })
        .catch((error) => {
            console.log(error);
        });
    }

    const loadUnit = (building_id) => {
        ClientsService.getBuildingUnits(building_id)
        .then((res) => {
            console.log(res.data);
            setUnits(res.data);
            // loadProvince(res.data[0]);
        })
        .catch((error) => {
            console.log(error);
        });
    }



    const loadEventType = () => {
        EventsService.getEventTypes()
        .then((res) => {
            console.log("EVENT TYPES FROM API =", res.data);
            setEventType(res.data);
        })
        .catch((error) => {
            console.log(error);
        });
    }



    const [eventTableData, setEventTableData] =
                        useState({"columns" : eventColumns, "rows":[]});

    const getEvents = () => {
        setEventTableData({"columns" : eventColumns, "rows":[]})
        EventsService.getEvents()
        .then((res) => {
            console.log(res.data);
            setEventTableData( {
                "columns": eventColumns,
                "rows": res.data.map(function(element) {
                        return {
                              id: element.id,
                              name: element.name,
                              unit: element.unit,
                              creator: element.creator,
                              type: element.type,
                              client: element.client,
                              building: element.building,
                              date: element.date,
                              time: element.time,
                              description: element.description  ,
                              // status: element.status  ,
                              status: <MDBadge badgeContent={element.status} size="sm" container
                                       color={element.status === "active" ? "success" : "dark"} />,

                              action: (
                                  <div>

                                      <GHIconButton
                                        onClick={handleClickItem}
                                        id={element.id}
                                        action={"change_status"}   
                                        rowName={element.client_name}
                                        title={"Cancel"}
                                        color={"warning"}
                                        icon={"cancel"}
                                        size={"medium"}
                                      />
                                      <GHIconButton onClick={handleClickItem} id={ element.id} action={"delete"}
                                                    rowName={element.client_name} title={"Remove"} color={"error"}
                                                    icon={"delete"} size={"medium"} />

                                  </div>
                              ),
                            }
                    })
            })

        })
        .catch((error) => {
          console.log(error);
        });
    }

    const [clickedItemId, setClickedItemId] = useState(0);

    const [openInsertModel, setOpenInsertModel] = useState(false);
    const [openUserModel, setOpenUserModel] = useState(false);

    const handleOpen = (event, model) => {
        switch (model){
            case "insert":
                setOpenInsertModel(true);
                break;
            case "delete" :
                handleOpenDialog(model);
                break;
            case "change_status":
                handleOpenDialog(model);
                break;
        }
    }
    const handleClose = (model) => {
        switch (model){
            case "insert":
                setOpenInsertModel(false);
                break;
        }
    }


    const [dialogAction, setDialogAction] = useState("")
    const handleOpenDialog = (action) => {
        setOpenDialog(true);
        setDialogAction(action)
    }
    const handleCloseDialog = () => setOpenDialog(false);

const handleAgreeDeleteDialog = () => {
  console.log("DIALOG CONFIRMED", { dialogAction, clickedItemId });

  setOpenDialog(false);

  if (dialogAction === "delete") {
    EventsService.removeEvent(clickedItemId)
      .then((res) => {
        console.log("DELETE SUCCESS", res?.data);
        openInfoSB();
        getEvents();
      })
      .catch((err) => {
        console.log("DELETE ERROR", err);
        const message =
          err?.response?.data?.status ||
          err?.response?.data?.message ||
          err?.message ||
          "Unknown error";
        setErrorMessage(message);
        openErrorSB();
      });
  }

  if (dialogAction === "change_status") {
    EventsService.disableEvent(clickedItemId)
      .then((res) => {
        console.log("DISABLE SUCCESS", res?.data);
        openInfoSB();
        getEvents();
      })
      .catch((err) => {
        console.log("DISABLE ERROR", err);
        const message =
          err?.response?.data?.status ||
          err?.response?.data?.message ||
          err?.message ||
          "Unknown error";
        setErrorMessage(message);
        openErrorSB();
      });
  }
};

function handleClickItem(e) {

  const el = e.currentTarget

  const actionToDo = el.getAttribute("action")
  const rowName = el.getAttribute("rowname")
  const rowId = el.getAttribute("id")

  console.log("EVENT BUTTON CLICKED")
  console.log("ACTION =", actionToDo)
  console.log("ROW ID =", rowId)
  console.log("ROW NAME =", rowName)

  setClickedItemId(rowId)
  setSelectedClientTitle(rowName)

  switch (actionToDo) {

    case "edit":
      handleOpen(e, "edit")
      break

    case "change_status":
      handleOpen(e, "change_status")
      break

    case "delete":
      handleOpen(e, "delete")
      break

    default:
      console.log("UNKNOWN ACTION =", actionToDo)
      break
  }
}

    const [userTableData, setUserTableData] = useState({});
    const [selectedClientTitle, setSelectedClientTitle] = useState("");

    const renderDialog = () => {
        return (
            <Dialog
                open={openDialog}
                keepMounted
                onClose={handleCloseDialog}
                aria-describedby="alert-dialog-slide-description"
              >
                <DialogTitle><Icon color={"warning"} >warning</Icon>{" Delete/Disable confirmation"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                Are you sure to Delete/Disable this item ?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <MDButton onClick={handleCloseDialog} >Disagree</MDButton>
              <MDButton onClick={handleAgreeDeleteDialog}  size={"large"}  color={"info"}  >Agree</MDButton>
            </DialogActions>
          </Dialog>
        )
    }


    const saveDataClicked = (e) =>{
        e.preventDefault();
        if(!validateEventValues(values)){
            setErrorMessage("Please fill all required fields");
            openErrorSB();
            return;
        }
        // console.log(values)
let dataToSend = {
    name: values.title,
    date: values.doDate,
    start_time: values.startTime,
    end_time: values.endTime,
    type: values?.eventType?.id,
    client: values?.client?.id,
    building: values?.building?.id,
    unit: values?.unit?.map(u => u.id) ?? [],
    description: values.description,
    notify_member: values.notificationUser
}
            console.log(dataToSend);

            EventsService.insertEvent(dataToSend)
                .then((response) =>{
                    console.log(response);
                    openInfoSB();
                    window.location.reload();
                })
                .catch((err) => {
                  console.log("INSERT ERROR =", err);

                  const message =
                    err?.response?.data?.status ||
                    err?.response?.data?.message ||
                    err?.message ||
                    "Unknown error";

                  setErrorMessage(message);
                  openErrorSB();
                });
        // handleClose();
    }

    const renderSB = (
        <div>
            <MDSnackbar
              color="success"
              icon="notifications"
              title="Amenity System"
              content="Your data saved successfully"
              dateTime=""
              open={infoSB}
              onClose={()=>setInfoSB(false)}
              close={()=>setInfoSB(false)}  />

            <MDSnackbar
              color="error"
              icon="error"
              title="Amenity System"
              content={errorMessage}
              dateTime=""
              open={errorSB}
              onClose={()=>setErrorSB(false)}
              close={()=>setErrorSB(false)}/>
        </div>
    );
    const [editMode, setEditMode] = useState(false);
    const renderInsertModal = () => {
        return <Modal open={openInsertModel} onClose={(e)=>{handleClose("insert")}} color={"warning"} >
          <MDBox sx={modalStyleClients}>
            <Card id="basic-info" sx={{ overflow: "visible" }}>
              <MDBox p={3}>
                <MDTypography variant="h5" >{editMode ? "Edit Event": "Insert New Event"}</MDTypography>
              </MDBox>
              <MDBox component="form" pb={3} px={3}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={12}>
                    <TextField
                          fullWidth
                          required
                          error={!!fieldErrors.title || !!errors.title}
                          helperText={fieldErrors.title || errors.title?.message}
                          value={values.title}
                          {...register("title")}
                          onChange={(event) => {
                            console.log("INPUT CHANGED", event.target.value);
                            handleChange({ ...values, title: event.target.value });
                          }}
                        label="Event Title"
                        placeholder="Glass Cleaner"  />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                          fullWidth
                          required
                          type={"date"}
                          error={!!fieldErrors.doDate || !!errors.doDate}
                          helperText={fieldErrors.doDate || errors.doDate?.message}
                          value={values.doDate}
                          {...register("doDate")}
                          onChange={(event) => {
                            handleChange({ ...values, doDate: event.target.value })
                          }}  />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                          fullWidth
                          required
                          type={"time"}
                          variant={"standard"}
                          error={!!fieldErrors.startTime || !!errors.startTime}
                          helperText={fieldErrors.startTime || errors.startTime?.message}
                          value={values.startTime}
                          {...register("startTime")}
                          onChange={(event) => {
                            handleChange({ ...values, startTime: event.target.value })
                          }}
                        label="Start Time"
                        placeholder="18:30"  />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                          fullWidth
                          required
                          type={"time"}
                          variant={"standard"}
                          label={"End Time"}
                          error={!!fieldErrors.endTime || !!errors.endTime}
                          helperText={fieldErrors.endTime || errors.endTime?.message}
                          value={values.endTime}
                          {...register("endTime")}
                          onChange={(event) => {
                            handleChange({ ...values, endTime: event.target.value })
                          }}
                        placeholder="20:30"  />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Autocomplete
                          required
                          options={clients}
                          value={values.client}
                          clearIcon={false}
                          clearOnBlur={false}
                          contentEditable={false}
                          getOptionLabel={(option) => option.client_name ?? "loading...."}
                          onChange={(event,value) => {
                             handleChange({ ...values, client: value, building: null, unit: [] });
                             if (value?.id) 
                              loadBuilding(value.id);
                          }}
                          renderInput={(params) => (
                            <MDInput {...params}
                                        error={!!fieldErrors.client || !!errors.client}
                                        helperText={fieldErrors.client || errors.client?.message}
                                        label="Client"
                                        InputLabelProps={{ shrink: true }}
                                        {...register("client")}/>
                          )}
                        />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Autocomplete
                          required
                          options={buildings}
                          value={values.building}
                          clearIcon={false}
                          contentEditable={false}
                          getOptionLabel={(option) => option.name ?? "loading...."}
                          onChange={(event,value) => {
                             handleChange({ ...values, building: value, unit: [] });
                             if (value?.id) 
                              loadUnit(value.id);
                          }}
                          renderInput={(params) => (
                            <MDInput {...params}
                                        error={!!fieldErrors.building || !!errors.building}
                                        helperText={fieldErrors.building || errors.building?.message}
                                        label="Building"
                                        InputLabelProps={{ shrink: true }}
                                        {...register("building")} />
                          )}
                        />

                  </Grid>
                  <Grid item xs={12} md={4}>
                     <Autocomplete
                          required
                          options={eventType}
                          value={values.eventType}
                          clearIcon={false}
                          clearOnBlur={false}
                          contentEditable={false}
                          getOptionLabel={(option) => option.type ?? "loading...."}
                          onChange={(event,value) => {
                            handleChange({ ...values, eventType: value });
                          }}
                          renderInput={(params) => (
                            <MDInput {...params}
                                        error={!!fieldErrors.eventType || !!errors.eventType}
                                        helperText={fieldErrors.eventType || errors.eventType?.message}
                                        label="EventType"
                                        InputLabelProps={{ shrink: true }}
                                        {...register("eventType")}/>
                          )}
                        />
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <MDTypography color={"secondary"} textGradient={true} opacity={0.5} component="caption"
                                  sx={{"paddingBottom":3}} >If You want to select custom units you can choose from list below</MDTypography>
                    <Autocomplete
                          required
                          options={units}
                          value={values.unit}
                          clearIcon={false}
                          contentEditable={false}
                          multiple
                          getOptionLabel={(option) => option.unit ?? "loading...."}
                          onChange={(event,value) => {
                            handleChange({ ...values, unit: value });
                          }}
                          renderInput={(params) => (
                            <MDInput {...params}
                                        error={!!fieldErrors.unit || !!errors.unit}
                                        helperText={fieldErrors.unit || errors.unit?.message}
                                        label="Unit (If Exist)"
                                        InputLabelProps={{ shrink: true }}
                                        {...register("unit")} />
                          )}
                        />
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <TextField
                          fullWidth
                          multiline={true}
                          aria-multiline={true}
                          error={!!errors.description}
                          helperText={errors.description?.message}
                          value={values.description}
                          {...register("description")}
                          onChange={(event) => {
                            handleChange({ ...values, description: event.target.value })
                          }}
                        label="Event Description (Multi Line)"
                        placeholder="Write Event Description Here"  />
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
                      <MDBox mt={0.5} >
                        <Switch checked={values.notificationUser}   onChange={() =>
                            handleChange({ ...values, notificationUser: !values.notificationUser })
                        } />
                      </MDBox>
                      <MDBox width="80%" ml={0.5}>
                        <MDTypography variant="button"  fontWeight="regular" color="text">
                          Notification To Member
                        </MDTypography>
                      </MDBox>
                    </MDBox>
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <MDButton color={"info"} size={"large"}
                              onClick={handleSaveEvent} >Save Data</MDButton>
                  </Grid>
                </Grid>
              </MDBox>
            </Card>
          </MDBox>
        </Modal>
    };


    const renderEventList = () => {
        return(
            <MDBox my={3}>
              {renderSB}
              {renderInsertModal()}
              {renderDialog()}
              <MDBox  display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}>
                  <MDButton variant="gradient" color="warning" size="large"
                            disabled={selectedInstance.id === ""} onClick={(e) => {handleOpen(e,"insert")}}>
                    new event
                  </MDButton>
              </MDBox>
              <Card>
                    <DataTable showTotalEntries={true}
                       table={eventTableData}
                       entriesPerPage={false}
                       canSearch />
              </Card>
            </MDBox>
        )
    };

    return (
        <DashboardLayout>
          <DashboardNavbar />
            {renderEventList()}
          <Footer />
        </DashboardLayout>
    );


}

export default EventList;
